export default __webpack_public_path__ + "static/images/platform2.ca9aee9d.jpg";